var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatStetementReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 58.971,
    y1: 53.744,
    x2: 67.011,
    y2: 53.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 69.238,
    y1: 65.291,
    x2: 77.278,
    y2: 65.291,
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 59.655,
    y1: 59.425,
    x2: 76.741,
    y2: 59.425,
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 249.548,
    y1: 85.839,
    x2: 279.649,
    y2: 85.839,
    gradientTransform: "matrix(.55 0 0 1 -86.943 28.182)",
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 106.843,
    y1: 71.317,
    x2: 150.397,
    y2: 71.317,
    gradientTransform: "matrix(.823 0 0 1 -37.745 28.171)",
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: -2866.724,
    y1: -294.931,
    x2: -2815.318,
    y2: -294.931,
    gradientTransform: "matrix(0 .881 -1 0 -227.089 2608.869)",
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 99.389,
    y1: 75.729,
    x2: 144.016,
    y2: 75.729,
    gradientTransform: "matrix(.84 0 0 .909 -34.506 37.396)",
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2",
    x1: 94.558,
    y1: 133.279,
    x2: 120.307,
    y2: 133.279,
    xlinkHref: "#SVGID_0_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M93.465 83.021h71.118l-41.162-25.065-29.699 18.085M104.128 83.482v24.578M153.266 83.482v36.912h-10.663V83.482M128.922 120.394h34.653"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 62.991,
    cy: 53.744,
    r: 2.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 73.258,
    cy: 65.291,
    r: 2.77,
    stroke: "url(#SVGID_1_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_2_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)",
    d: "M60.905 67.901l14.586-16.952"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M83.014 136.707H42.482V44.278h50.757v68.406M49.641 75.522l8.66-.067M73.664 111.395h6.406M73.634 116.432h6.406M77.173 75.522l8.66-.067M63.466 75.522l8.66-.067"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_3_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)",
    d: "M51.107 114.021H66.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_4_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)",
    d: "M51.228 99.488h33.793"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_5_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)",
    d: "M67.844 85.044v43.074"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_6_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)",
    d: "M85.403 121.491V83.626H50.02v45.281h32.554"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 107.487,
    cy: 132.581,
    r: 24.457
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_7_faaa36c8a31c2a3431672810eab9bef5651b24b234bde79c060764f5fbf778e2)",
    d: "M95.808 133.051l8.206 9.117 15.043-17.779"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatStetementReport);
export default __webpack_public_path__ + "static/media/vatStetementReport.abf031f9406bc3ab4db66f3bdba41d9c.svg";
export { ForwardRef as ReactComponent };